export default __webpack_public_path__ + "static/media/browserstack.371e05c7.svg";